<template>
  <g
    id="Rear_Left_Indicator"
    v-on:click="changeSeverity('rearLeftIndicator')"
    :class="severityClass"
  >
    <rect
      class="cls-892"
      x="64.11"
      y="280.36"
      width="9.27"
      height="2.23"
      transform="translate(137.5 562.95) rotate(180)"
    />
    <g>
      <circle
        class="cls-208"
        cx="76.59"
        cy="281.48"
        r="5.2"
        transform="translate(-176.6 136.6) rotate(-45)"
      />
      <circle
        class="cls-458"
        cx="76.59"
        cy="281.48"
        r="5.09"
        transform="translate(-176.6 136.6) rotate(-45)"
      />
      <circle class="cls-170" cx="76.59" cy="281.48" r="4.98" />
      <circle class="cls-300" cx="76.59" cy="281.48" r="4.87" />
      <circle class="cls-135" cx="76.59" cy="281.48" r="4.76" />
      <circle class="cls-301" cx="76.59" cy="281.48" r="4.65" />
      <circle class="cls-403" cx="76.59" cy="281.48" r="4.54" />
      <circle class="cls-363" cx="76.59" cy="281.48" r="4.43" />
      <circle class="cls-364" cx="76.59" cy="281.48" r="4.32" />
      <circle class="cls-31" cx="76.59" cy="281.48" r="4.22" />
    </g>
  </g>
</template>

<script>
export default {
  props: {
    severityClass: String
  },
  methods: {
    changeSeverity(section) {
      this.$emit('changeSeverity', section);
    }
  }
};
</script>
